<div class="tabs-container" role="tablist">
  <div *ngFor="let tab of tabs">
    <button
      class="tab-button"
      [ngClass]="{
        'tab-button--active': isActive(tab),
        'tab-button--disabled': !tab.isAvailable
      }"
      [attr.aria-label]="tab.displayName"
      [attr.aria-selected]="isActive(tab)"
      (click)="changeTab(tab)"
      role="tab"
    >
      <div class="label-container">
        <div class="header">
          <div class="header-title" [attr.header-title]="tab.displayName">
            {{ tab.displayName }}
          </div>
        </div>
        <div class="icon-text-container" *ngIf="!tab.isAvailable">
          <span class="glyph-bullhorn margin-right-xsmall"></span>
          <span class="coming-soon-text">Coming Soon</span>
        </div>
      </div>
    </button>
  </div>
</div>
